import { styled } from 'styled-components';

import { colors, fonts } from '#/theme/theme';

const locationRadiusSelectChevronDisplayVar =
  '--local-location-radius-display-chevron';

export const LocationRadiusSelectHolder = styled.div`
  position: relative;
  flex-shrink: 0;
  color: ${colors.black};

  &:has(select:disabled) {
    opacity: 0.75;
    ${locationRadiusSelectChevronDisplayVar}: none;
  }
`;

export const LocationRadiusSelectStyled = styled.select<{
  $fullWidth: boolean;
}>`
  appearance: none;
  height: 43px;
  background: ${colors.inputGrey};
  border: none;
  padding-top: 11px;
  padding-bottom: 11px;
  padding-left: 40px;
  padding-right: 40px;
  border-radius: 8px;
  font-size: 18px;
  font-family: ${fonts.sans};
  color: inherit;
  width: ${(props) => props.$fullWidth && '100%'};

  &:focus {
    border-color: ${colors.brandBlue};
    box-shadow: 0 0 0 1px ${colors.brandBlue} inset;
    outline: 0;
  }
`;

export const LocationRadiusSelectLeftIconHolder = styled.div`
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
`;

export const LocationRadiusSelectChevronHolder = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: var(${locationRadiusSelectChevronDisplayVar});
`;
